import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
export type MarketActivityFragment = { __typename?: 'MarketActivityStats' } & {
    data?: Types.Maybe<
        { __typename?: 'MarketActivityStatsData' } & Pick<
            Types.MarketActivityStatsData,
            'averagePricePaid' | 'propertiesSold'
        >
    >;
    error?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'MarketActivityStatsErrorMessage' } & Pick<
                    Types.MarketActivityStatsErrorMessage,
                    'message' | 'code' | 'path'
                >
            >
        >
    >;
};

export const MarketActivityFragmentDoc = gql`
    fragment MarketActivity on MarketActivityStats {
        data {
            averagePricePaid
            propertiesSold
        }
        error {
            message
            code
            path
        }
    }
`;
